module.exports = __webpack_public_path__ + "img/20220624173720.26114933.png";